import { InstructionOptionDTO } from 'models/purchaseFlow'
import { ProductKind } from 'constants/product'
import { bigFromFee } from 'utils/price'

/** The invoice card's state on the billing screen, as `invoice_option` on enters_order_billing_selection_screen (ISSUE-4023). */
export type InvoiceOption = 'waived' | 'paid' | 'locked' | 'not_offered'

/**
 * `waived`: the invoice is free and selectable (subscription, invoice flag, or an admin order). `paid`: the invoice
 * carries a fee and anyone may select it. `locked`: shown free but not selectable, because the client has neither a
 * subscription nor the invoice flag (the subscription upsell in the web app, a dead end in the embed). `not_offered`:
 * the catalogue returned no invoice option. The same rule decides the card's selectability.
 */
export const resolveInvoiceOption = (
  availablePaymentMethods: Partial<Record<ProductKind, InstructionOptionDTO>>,
  { isAdmin, invoiceAllowed }: { isAdmin: boolean, invoiceAllowed: boolean }
): InvoiceOption => {
  const invoice = availablePaymentMethods[ProductKind.INVOICE_BY_EMAIL]
  if (!invoice) return 'not_offered'
  if (bigFromFee(invoice.feePrice).gt(0)) return 'paid'
  return isAdmin || invoiceAllowed ? 'waived' : 'locked'
}
